<template>
  <footer class="py-5 footer">
    <div class="container">
      <div class="row">
        <div class="mx-auto mt-1 text-center col-8"> 
            © {{ new Date().getFullYear() }}, made with bob
            <i class="fa fa-heart" aria-hidden="true"></i> by
            <a href="https://runsolutions.is" class="font-weight-bold" target="_blank" rel="noopener noreferrer">Rún Solutions</a>
        </div>
      </div>
    </div>
</footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>
